import styles from './Login.module.css';

import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from 'react-google-login';
import axios from 'axios';
import config from 'config.js';
import { Button, Input, FormRow, Hr, Spinner } from 'ui-components';
import { withRouter } from 'react-router';
import validator from 'validator';

import { MainContext } from 'contexts/main.js';

import { ReactComponent as LogoIcon } from 'assets/images/logo-icon-bw.svg';

const Login = ({ history }) => {
  const { isAuthenticated, checkAuthentication, setOtpToken } = useContext(MainContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formEmail, setFormEmail] = useState('');
  const [formPassword, setFormPassword] = useState('');

  const handleSubmit = async (type, params = {}) => {
    setLoading(true);
    setError(null);

    if (type === 'email') {
      params = {
        email: formEmail,
        password: formPassword
      };
    }

    try {
      const { data } = await axios.post(`${config.apiUrl}/auth/${type === 'email' ? 'login' : 'create'}`, params);

      if (data && data.token) {
        if (data.type === 'auth') {
          window.localStorage.setItem('token', data.token);

          checkAuthentication();
        } else if (data.type === 'otp') {
          setOtpToken(data.token);

          history.push('/otp');
        }
      }
    } catch (e) {
      setError(e?.response?.data?.message);
    }

    setLoading(false);
  };

  const handleEnterKeyPress = (e) => {
    if (e.key !== 'Enter') return;
    if (!validator.isEmail(formEmail)) return;

    handleSubmit('email');
  };

  useEffect(() => {
    if (isAuthenticated) history.push('/');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return (
    <>
      <LogoIcon className={styles.logo} />

      <div className={styles.createAnCccount}>
        <span>Don’t have an account yet?</span>
        <Button theme="black-underline" link="/signup" icon="open-external" iconPlacement="right">
          Create an account
        </Button>
      </div>

      <div className={styles.main}>
        <div className={styles.header}>Welcome back</div>
        <div className={styles.subHeader}>Select a sign in method</div>

        <div className={styles.form}>
          <GoogleLogin
            clientId="454161137540-8u87841b6qvv2ncqof3o6uprkecrpa3f.apps.googleusercontent.com"
            onSuccess={(data) =>
              handleSubmit('google', {
                tokenId: data.tokenId,
                type: 'google'
              })
            }
            onFailure={console.log}
            cookiePolicy="single_host_origin"
            render={(renderProps) => (
              <Button
                style={{ margin: '0 0 10px 0' }}
                theme="white"
                icon="google"
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
                size="medium"
                fullWidth>
                Sign in using Google
              </Button>
            )}
          />

          <FacebookLogin
            appId="481165379133345" // dev 401006260736891 / prod 481165379133345
            autoLoad={false}
            callback={(data) => {
              if (data && data.accessToken)
                handleSubmit('facebook', {
                  accessToken: data.accessToken,
                  type: 'facebook'
                });
            }}
            fields="name,email"
            render={(renderProps) => (
              <Button theme="white" icon="facebook" onClick={renderProps.onClick} disabled={renderProps.disabled} size="medium" fullWidth>
                Sign in using Facebook
              </Button>
            )}
          />

          <Hr textBackground="#FBFAF9">or sign in with your email</Hr>

          <FormRow label="Email Address">
            <Input
              name="email"
              type="email"
              style={{ margin: '0 0 0 0' }}
              placeholder="email"
              autoFocus={true}
              value={formEmail}
              onChange={(value) => setFormEmail(value)}
              onKeyPress={handleEnterKeyPress}
            />
          </FormRow>

          <FormRow label="Password" className={styles.password}>
            <Input
              name="password"
              type="password"
              style={{ margin: '5px 0 0 0' }}
              placeholder="password"
              value={formPassword}
              onChange={(value) => setFormPassword(value)}
              onKeyPress={handleEnterKeyPress}
            />

            <Link to="/forgot" className={styles.forgot}>
              I forgot my password
            </Link>
          </FormRow>

          <Button
            style={{ margin: '20px 0 0 0' }}
            fullWidth={true}
            theme="black"
            onClick={() => handleSubmit('email')}
            className={styles.submit}
            disabled={!formPassword || !formPassword || loading || !validator.isEmail(formEmail)}>
            Sign in with email
          </Button>

          {error && <div className={styles.error}>{error}</div>}
        </div>

        {loading && (
          <div className={styles.loader}>
            <Spinner size={40} borderSize={2} speed="0.8s" />
          </div>
        )}
      </div>
    </>
  );
};

export default withRouter(Login);
